import React, { useState } from 'react';
import { Collapse, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';

import { TableSecProps } from './props';

import { MovimentacoesServices } from '../../services/movimentacoesService';
import { maskCurrency, maskDate, maskUnd } from '../../../../utils/mask';
import ModalAtendimentoEntrada from '../Modal';
import { RowLine, SpanBlock } from './styles';

const CardSecMobile: React.FC<TableSecProps> = ({ nuNota }) => {
  const { Panel } = Collapse;
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await MovimentacoesServices.getNotasSecundarias(nuNota, cddAtivo?.codCdd).then((res) => {
        setResponse(res.data.notas);
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Collapse onChange={handleClick} key={nuNota}>
      <Panel header="Detalhes" key={nuNota}>
        {loading ? (
          <Spin size="small" />
        ) : (
          response.map((item: any) => {
            return (
              <>
                <RowLine>
                  <p>
                    <strong>N° atendimento: </strong>
                    <SpanBlock> {item.nuNota}</SpanBlock>
                  </p>
                  <p>
                    <strong>Nota: </strong>
                    <SpanBlock>
                      {<ModalAtendimentoEntrada text={item.numNota} nuNota={item.nuNota} />}
                    </SpanBlock>
                  </p>
                  <p>
                    <strong>Data lançamento: </strong>
                    <SpanBlock> {maskDate(item.dtLancamento)}</SpanBlock>
                  </p>
                </RowLine>

                <p>
                  <strong>Emitente: </strong>
                  <SpanBlock> {item.emitente}</SpanBlock>
                </p>
                <p>
                  <strong>Movimentação: </strong>
                  <SpanBlock> {item.movimentacao}</SpanBlock>
                </p>

                <RowLine>
                  <p>
                    <strong>Peso bruto: </strong>
                    <SpanBlock> {maskUnd(item.pesoBruto) + ' KG'}</SpanBlock>
                  </p>
                  <p>
                    <strong>Valor da mercadoria: </strong>
                    <SpanBlock> {maskCurrency(item.vlrMercadoria)} </SpanBlock>
                  </p>
                </RowLine>
                <p>
                  <strong>Chave da nota: </strong>
                </p>
                <p style={{ wordWrap: 'break-word' }}>{item.chaveNfe}</p>
                <hr />
              </>
            );
          })
        )}
      </Panel>
    </Collapse>
  );
};

export default CardSecMobile;
